import * as React from "react";
import { userHasPermission } from "@eduviaos/shared";
import { useAuth } from "@/auth/AuthProvider";

export interface FeesAuthoringGate {
  canViewFees: boolean;
  canManageFees: boolean;
  missingView: boolean;
}

export function useCanManageFees(): FeesAuthoringGate {
  const { user } = useAuth();
  return React.useMemo<FeesAuthoringGate>(() => {
    if (!user) {
      return { canViewFees: false, canManageFees: false, missingView: false };
    }
    const overrides = user.permission_overrides ?? [];
    const canView = userHasPermission(
      user.role,
      overrides,
      "view_fees",
      user.permission_mode ?? "additive",
    );
    const canManage = userHasPermission(
      user.role,
      overrides,
      "manage_fees",
      user.permission_mode ?? "additive",
    );
    return {
      canViewFees: canView,
      canManageFees: canManage,
      missingView: !canView,
    };
  }, [user]);
}
